export const COPILOT_FEEDBACK_PATH_NAME = 'co-pilot/feedback';
